import { useGetComponentStatusForPortalQuery } from '../../__generated__/chirp/com/hubspot/ubb/component/status/service/rpc/UbbComponentStatusServiceAppRpc.hooks';
import { useGetComponentStatusQuery } from '../../__generated__/chirp/com/hubspot/ubb/component/status/service/rpc/UbbComponentStatusServiceExternalRpc.hooks';
import { useUserInfo } from './useUserInfo';
export const useIsComponentEnabled = component => {
  const userInfo = useUserInfo();
  const isAuthenticated = !!(userInfo !== null && userInfo !== void 0 && userInfo.user);

  // For authenticated users: Use app-auth service with portal-specific overrides
  const {
    data: appAuthData
  } = useGetComponentStatusForPortalQuery({
    variables: {
      component
    },
    skip: !isAuthenticated // Skip if not authenticated
  });

  // For unauthenticated users: Use external service (global status only)
  const {
    data: externalData
  } = useGetComponentStatusQuery({
    variables: {
      component
    },
    skip: isAuthenticated // Skip if authenticated
  });
  const data = isAuthenticated ? appAuthData : externalData;
  return (data === null || data === void 0 ? void 0 : data.enabled) !== false;
};